Directives.NetworkEditProjectFormDirective = function NetworkEditProjectFormDirective() {

    // @ngInject
    function NetworkEditProjectFormDirectiveControllerFunc($scope, $injector, $filter, $state, $stateParams, _, UsersManager,
                                                           NetworkManager, NetworkService, AnalyticsService, ModelFactory, $timeout, PopupMessageService, AppStates, EventsManager) {

        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'NetworkEditProjectFormDirectiveController';
        this.projectId = !this.defaultEvent ? (this.editProjectId ? this.editProjectId : $stateParams.project_id) : null;
        this.NetworkManager = NetworkManager;
        this.NetworkService = NetworkService;
        this.AnalyticsService = AnalyticsService;
        this.ModelFactory = ModelFactory;
        this._ = _;
        this.projectData = this.projectData || {};
        this.UsersManager = UsersManager;
        this.currUser = this.NetworkManager.getNetworkCurrUser();
        this.deleting = false;
        this.PopupMessageService = PopupMessageService;
        this.locationGeocoded = false;
        this.setPhotoAsDefaultText = 'Set as cover';
        this.photoIsCoverText = 'Current project cover';
        this.$state = $state;
        this.AppStates = AppStates;

        if (this.projectId) {
            this.project = this.NetworkManager.getProject(this.projectId);
        } else {
            // this.project = this.ModelFactory.newNetworkProjectModel();
            this.project = this.NetworkManager.createNetworkProject({});
            // this.project.members = [this.currUser];
            // this.project.member_ids = [this.currUser._id];
            this.selectedProjectType = this.NetworkService.getSelectedProjectTypeFromEnum();
            $timeout(function() {
                angular.element('#network-project-name').focus();
            }.bind(this), 500);
        }

        this.projectTypes = this.NetworkService.getProjectTypesEnum();
        this.isSavingProject = false;
        this.dropdownChanged = false;
        this.vendorTagged = false;
        this.imageAdded = false;
        this.imageDeleted = false;
        this.coverChanged = false;

        this.projectLoaded = false;

        this.$stateParams = $stateParams;

        if (this.$stateParams && this.$stateParams.focus_id && this.$stateParams.focus_id.length) {
            $timeout(function() {
                angular.element('#' + this.$stateParams.focus_id).focus();
            }.bind(this), 500);
        }

        this.project.on('success', function(){

            if (!this.projectId){
                this.projectId = this.project._id;
                this.onProjectSuccess({project: this.project});
            }

            // Don't allow non-creators to edit project
            if (this.currUser._id !== this.project.creator._id) {
                this.goToState(this.AppStates.root_network_project, {project_id: this.projectId});
            }

            // Don't let photo upload success clear projectData fields
            if (!this.projectLoaded) {
                var defaultProjectDate = this.defaultEvent && this.defaultEvent.event_date;
                var defaultProjectName = this.defaultEvent && this.defaultEvent.event_name;
                var defaultProjectDescription = this.defaultEvent && this.defaultEvent.event_details;
                var defaultProjectLocation = this.defaultEvent && this.defaultEvent.event_location;
                var defaultProjectImage = this.defaultEvent && this.defaultEvent.event_image;
                var eventUsers = this.defaultEvent && this.defaultEvent.event_users;

                var defaultProjectMembers = this._.filter(eventUsers, function (user) {
                    return (user.system_user_type === 'vendor' && this.currUser._id !== user._id);
                }.bind(this));

                var defaultProjectType = this._.find(this.projectTypes, function(projectType) {
                    return projectType.key === (this.defaultEvent && this.defaultEvent.project_type.toLowerCase());
                }.bind(this));

                this.projectData = angular.extend(this.projectData, {
                    _id: this.project._id,
                    project_name: (this.project.project_name || defaultProjectName),
                    project_type: (this.project.project_type || (defaultProjectType && defaultProjectType.key)),
                    project_date: $filter('date')((this.project.project_date || defaultProjectDate) , "MMM dd, yyyy"),
                    description: (this.project.description || defaultProjectDescription),
                    guests: this.project.guests,
                    tags: this.project.tags!== null && this.project.tags.length ? this.project.tags.join(', ') : '',
                    location: (this.project.location || defaultProjectLocation),
                    member_ids: this.project.member_ids,
                    coordinates: this.project.coordinates
                });

                if(this.defaultEvent) {
                    this.projectData.event_id = this.defaultEvent._id;
                }

                if(defaultProjectImage) {
                    this.addImage(defaultProjectImage);
                }

                defaultProjectMembers.forEach(function(user) {
                    this.NetworkManager.addNetworkUserFromProject(user, this.project).then(
                        function success(resp) {
                            user = user.mixinFrom(resp.data);
                            if(this.project.members){
                                this.project.members.push(user);
                                this.project.member_ids.push(user._id);
                            } else {
                                this.project.members = [user];
                                this.project.member_ids = [user._id];
                            }

                            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_vendor_tagged_in_project,
                                {
                                    project_id: this.project._id,
                                    new_member_email: user.email,
                                    new_member_id: user._id,
                                    new_member_full_name: user.full_name
                                });
                        }.bind(this)
                    );
                }.bind(this));

                if(defaultProjectName && this.projectForm) {
                    this.projectForm.$dirty = true;
                }

                var projectType = this.project.project_type ? this.NetworkService.getSelectedProjectTypeFromEnum(this.project) : defaultProjectType;
                if(projectType) {
                    this.setProjectType(projectType);
                }

                this.projectLoaded = true;
            }

        }.bind(this));

        $scope.$watch('networkEditProjectVm.cancelProject', function (cancelProject) {
            if(cancelProject) {
                this.cancel();
            }
        }.bind(this));

    }

    var NetworkEditProjectFormDirectiveController = Class(Controllers.BaseController, {

        constructor: NetworkEditProjectFormDirectiveControllerFunc,


        isNewProject: function isNewProject() {
            return this.project.status === 'draft';
        },

        update: function update() {
            /* Save project information */

            if(this.isFormDirty()){
                this.isSavingProject = true;
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_save_project, this.projectData);
                if (this.projectId) {

                    if (this.isNewProject()){
                        // only for first time that draft is been saved
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_project_publish, {projectId: this.project._id});
                    }

                    // Edit existing project
                    this.NetworkManager.updateNetworkProject(this.project, this.projectData).then(
                        function success(){
                            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_edit_project, {projectId: this.project._id});
                            this._handleSaveSuccess();
                            this.onSaveSuccess({project: this.project});
                        }.bind(this),
                        function error(resp){
                            this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_edit_project, resp);
                            this.lastError = resp.data.error_message || resp.data;
                        }.bind(this))
                        .finally(function finallyHandler() {
                            this.isSavingProject = false;
                        }.bind(this));
                } else {
                    // Create a new project
                    this.project = this.NetworkManager.createNetworkProject(this.projectData);
                    this.project.on('success', function onSuccess(){
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_create_project, {projectId: this.project._id});
                        this._handleSaveSuccess();
                        this.isSavingProject = false;
                    }.bind(this));
                    this.project.on('error', function onError(message){
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_create_project, message);
                        this.lastError = message;
                        this.isSavingProject = false;
                    }.bind(this));
                }
            }
        },

        cancel: function cancel() {
            if (this.isNewProject()) {
                this.deleteProject();
            } else {
                this.onCancel();
            }
        },

        setProjectType: function setProjectType(type) {
            this.projectData.project_type = type.key;
            this.selectedProjectType = type;
            this.dropdownChanged = true;
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_edit_project_type, type.text);
        },

        isFormDirty: function isFormDirty() {
            return (this.projectForm.$dirty || this.dropdownChanged || this.vendorTagged || this.imageAdded || this.coverChanged || this.imageDeleted) && this.projectForm.$valid;
        },

        _handleSaveSuccess: function _handleSaveSuccess(){
            // Clear validations
            if (angular.isDefined(this.projectForm))
            {
                this.projectForm.$setPristine();
            }
            this.dropdownChanged = false;
        },
        createFileViewModel: function createFileModel(image) {
            var self = this;
            var fileViewModel = {
                instance: self.project, //the instance of the model containing these files
                type: 'project_gallery_image',
                dontUpdateServer: true,
                uploading: false,
                uploaded: true,
                dataUrl: null,
                url: null,
                file: null,
                progress: 0
            };

            if (image) {
                //add the attributes of the file to upload on the view-model
                this._.extend(fileViewModel, image);
            }

            return fileViewModel;
        },

        deleteImage: function deleteImage(image_id)
        {

            this.imageDeleted = true;
            // First send the delete to the server
            this.NetworkManager.deleteAsset(this.project, image_id);

            // Second update the model immediately for better UI experience
            var index;
            this._.any(this.project.gallery_assets, function (item, idx) {
                if (item._id === image_id) {
                    index = idx;
                    return true; // brake the iteration
                }
            });

            if (index !== undefined) {
                this.project.gallery_assets.splice(index, 1);
            }

            if (this.project.gallery_assets.length === 0) {
                this.project.default_cover_image_id = null;
            } else if (this.project.default_cover_image_id === image_id) {
                this.setFirstImageAsDefaultCoverImage();
            }
        },

        analyticsProperties: function analyticsProperties() {
            return {
                projectId: this.project._id
            };
        },

        openNetworkTagVendors: function openNetworkTagVendors() {
            this.NetworkService.tagNetworkVendors(this.project).then(
                function onMembersAdded(resp){
                    this.projectData["member_ids"] = this.project.member_ids;
                    this.vendorTagged = true;
                }.bind(this));
        },

        addImage: function addImage(s3response,type) {
            this.imageAdded = true;

            return this.NetworkManager.addImageToGallery(this.project, s3response, type).then(function () {
                if (this.project.default_cover_image_id == null) {
                    this.setFirstImageAsDefaultCoverImage();
                }
            }.bind(this));
        },

        deleteProject: function deleteProject() {

            var self = this;

            var deleteConfirmed = function deleteConfirmed(){
                self.deleting = true;
                self.analyticsArgs = {
                    projectId : self.project._id
                };

                self.NetworkManager.deleteNetworkProject(self.currUser, self.project._id).then(
                    function success() {
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.network_cancel_deleted_project, self.analyticsArgs);
                    },
                    function error() {
                        this.cancelProject = false;
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.network_cancel_deleted_project_error, self.analyticsArgs);
                    }
                ).finally(function done() {
                    self.deleting = false;
                    self.onCancel();
                });
            };

            var deleteDismissed = function deleteDismissed() {
                self.cancelProject = false;
            };

            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                'NETWORK.PROJECT._CONFIRM_CANCEL_DELETE_',
                deleteConfirmed, deleteDismissed);
        },

        blurLocation: function blurLocation(){
            if(!this.locationGeocoded && this.projectData.coordinates){
                this.projectData.coordinates = [];
            }
        },

        updateCoordinates: function updateCoordinates(geocodeResult){
            if(geocodeResult.geometry) {
                var longitude = geocodeResult.geometry.location.lng();
                var latitude = geocodeResult.geometry.location.lat();
                // MongoDB stores geospatical coordinates as long, lat
                this.projectData.coordinates = [longitude, latitude];
                this.locationGeocoded = true;
            }
        },

        setFirstImageAsDefaultCoverImage: function setFirstImageAsDefaultCoverImage() {
            var image_id = this.project.gallery_assets[0]._id;
            this.NetworkManager.setProjectCoverImage(this.project, image_id);
            this.project.default_cover_image_id = image_id;
            this.coverChanged = true;
        },

        setDefaultCoverImage: function setDefaultCoverImage(image_id) {
            this.NetworkManager.setProjectCoverImage(this.project, image_id);
            this.project.default_cover_image_id = image_id;
            this.coverChanged = true;
        }
    });

    return {
        scope: {
            defaultEvent: '=event',
            onSaveSuccess: '&',
            onCancel: '&',
            onProjectSuccess: '&',
            cancelProject: '=',
            showSubtitle: '=',
            hideTitle: '=',
            editProjectId: '='
        },
        templateUrl: 'angular/app/modules/network/features/project/network_edit_project_form_template.html',
        controller: NetworkEditProjectFormDirectiveController,
        controllerAs: 'networkEditProjectVm',
        bindToController: true
    };
};
